import React from "react";
import styled from "styled-components/macro";
import nacidTextSvg from "@duosoftbg/nacid-components/dist/assets/images/hero-text.svg";
import topSvg from "@duosoftbg/nacid-components/dist/assets/images/hero-top.svg";
import { Grid, Typography as MuiTypography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { spacing } from "@mui/system";

const Hero = styled.div`
  height: 200px;
  width: 100%;
  position: relative;
  text-align: center;
  overflow: hidden;
  background-position:
    100% 50%,
    100% 50%,
    50% 100%,
    0 0;
  background-size: cover, contain, contain, auto;
  background-repeat: no-repeat, no-repeat, no-repeat, repeat;
  background-image: url(${topSvg}), radial-gradient(closest-side, #003a73, #003a73);

  .title {
    position: relative;
    display: block;
    overflow: hidden;
    margin: 0;
    width: 100%;
    height: 100%;
  }
`;

const NacidTitle = styled.span`
  display: block;
  width: 100%;
  height: 50px;
  background: url(${nacidTextSvg}) center top no-repeat;
  background-size: auto;
  background-size: 100% 100%;
  margin-top: 40px;
  padding: 0;
`;

const Typography = styled(MuiTypography)(spacing);
const Title = styled(Typography)`
  font-weight: ${(props) => props.theme.typography.fontWeightBold};
  color: white;
  //text-shadow: 1px 0px #0b0b0b;
  text-align: center;
  font-variant: small-caps;
  margin: 10px 0 0 0;
  line-height: 1;
  font-size: 1.88rem;

  ${(props) => props.theme.breakpoints.down("sm")} {
    font-size: 1.5rem;
  }

  ${(props) => props.theme.breakpoints.up("sm")} {
    font-size: 1.75rem;
  }

  ${(props) => props.theme.breakpoints.up("md")} {
    font-size: 1.75rem;
  }

  span {
    color: ${(props) => props.theme.palette.primary.main};
  }
`;

function Introduction() {
  const { t } = useTranslation();
  return (
    <Hero>
      <div className={"title"}>
        <NacidTitle />
        <Grid style={{ marginTop: 20 }} alignItems="center" justifyContent="center" container>
          <Grid item xs={12} sm={12} md={8} lg={8}>
            <Title variant="h1" gutterBottom>
              {t("Портал за електронни услуги и регистри")}
            </Title>
          </Grid>
        </Grid>
      </div>
    </Hero>
  );
}

export default Introduction;
